import { Button, Classes, Dialog } from "@blueprintjs/core";
import { useContext } from "react";
import ReactJson from "react-json-view";
import { DarkThemeContext } from "src/utils/context";

import { TemplateProject } from "src/utils/utils";
type Props = {
    userProject: TemplateProject;
    close: () => void;
};
const JsonViewStyle = { maxHeight: "40rem", overflow: "auto" };

export default function InstructionPreviewDialog({ userProject, close }: Props) {
    const { __typename, companySysId, id, visible, ...rest } = userProject;
    const dark = useContext(DarkThemeContext);
    return (
        <Dialog icon="code" title={userProject.name} onClose={close} isOpen={true}>
            <div className={Classes.DIALOG_BODY}>
                <ReactJson style={JsonViewStyle} theme={dark ? "ashes" : undefined} src={rest} enableClipboard={true} displayDataTypes={false} displayObjectSize={false} />
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button onClick={close}>Close</Button>
                </div>
            </div>
        </Dialog>
    );
}
